import { z } from 'zod';
/** IoT thing group suffix: lowercase, dots → hyphens, underscores → hyphens */
export function toThingGroupSuffix(adapterKey) {
    return adapterKey.toLowerCase().replace(/\./g, '-').replace(/_/g, '-');
}
/** Profile keys from `greengrass-deploy-tools/deploy-profiles.json` (keep in sync when profiles are added). */
export const DeployProfileKeySchema = z.enum([
    'edge-device-guard',
    'axon-orchestrator',
    'matrix-orchestrator',
    'woxu-ls1000',
    'efem-csv-stub-adapter-1',
    'efem-csv-stub-adapter-2',
]);
export function edgeThingGroup() {
    return 'cci-edge';
}
export function tenantThingGroup(tenantId) {
    return `cci-tenant-${tenantId}`;
}
export function efemCategoryThingGroup() {
    return 'cci-axon';
}
export function locationCategoryThingGroup() {
    return 'cci-matrix';
}
export function efemUnassignedThingGroup() {
    return 'cci-axon-unassigned';
}
export function locationUnassignedThingGroup() {
    return 'cci-matrix-unassigned';
}
export function efemAdapterThingGroup(adapterKey) {
    return `cci-axon-adapter-${toThingGroupSuffix(adapterKey)}`;
}
export function locationAdapterThingGroup(adapterKey) {
    return `cci-matrix-adapter-${toThingGroupSuffix(adapterKey)}`;
}
/** Flat adapter leaf name when registry already provides `thingGroupSuffix`. */
export function adapterThingGroupNameFromSuffix(kind, thingGroupSuffix) {
    return kind === 'efem'
        ? `cci-axon-adapter-${thingGroupSuffix}`
        : `cci-matrix-adapter-${thingGroupSuffix}`;
}
/** Static catalogue groups (no tenant id, no per-adapter leaves). */
export function catalogueStaticThingGroupNames() {
    return [
        edgeThingGroup(),
        efemCategoryThingGroup(),
        locationCategoryThingGroup(),
        efemUnassignedThingGroup(),
        locationUnassignedThingGroup(),
    ];
}
export function thingGroupsForGateway(params) {
    const { tenantId, deviceCategory, efemAdapterKey, locationAdapterKey } = params;
    const groups = [edgeThingGroup(), tenantThingGroup(tenantId)];
    if (deviceCategory === 'efem-gateway') {
        groups.push(efemCategoryThingGroup());
        if (efemAdapterKey) {
            groups.push(efemAdapterThingGroup(efemAdapterKey));
        }
        else {
            groups.push(efemUnassignedThingGroup());
        }
    }
    else {
        groups.push(locationCategoryThingGroup());
        if (locationAdapterKey) {
            groups.push(locationAdapterThingGroup(locationAdapterKey));
        }
        else {
            groups.push(locationUnassignedThingGroup());
        }
    }
    return groups;
}
/** Flat `cci-*` groups managed by provision template and assignment sync. */
export function isManagedThingGroupName(groupName) {
    return groupName.startsWith('cci-');
}
export function greengrassDeployTargetGroup(deployTargetKind, adapterKey) {
    switch (deployTargetKind) {
        case 'edge':
            return edgeThingGroup();
        case 'efem':
            return efemCategoryThingGroup();
        case 'location':
            return locationCategoryThingGroup();
        case 'efem-adapter':
            if (!adapterKey)
                throw new Error('efem-adapter deploy target requires adapterKey');
            return efemAdapterThingGroup(adapterKey);
        case 'location-adapter':
            if (!adapterKey)
                throw new Error('location-adapter deploy target requires adapterKey');
            return locationAdapterThingGroup(adapterKey);
        default: {
            const _exhaustive = deployTargetKind;
            throw new Error(`Unknown deploy target kind: ${_exhaustive}`);
        }
    }
}
//# sourceMappingURL=iot-thing-groups.js.map